import { config } from "../../../../frontend.config";

export const localization: LocalizationConfig = {
    available: config.locales,
    locales: {
        de: {
            rtl: false,
            fonts: {
                primaryFont: "Domotika",
                secondaryFont: "SquadBlack",
                primaryFontRatio: 1,
            },
        },
        en: {
            rtl: false,
            fonts: {
                primaryFont: "Domotika",
                secondaryFont: "SquadBlack",
                primaryFontRatio: 1,
            },
        },
        es: {
            rtl: false,
            fonts: {
                primaryFont: "Domotika",
                secondaryFont: "SquadBlack",
                primaryFontRatio: 1,
            },
        },
        fr: {
            rtl: false,
            fonts: {
                primaryFont: "Domotika",
                secondaryFont: "SquadBlack",
                primaryFontRatio: 1,
            },
        },
        it: {
            rtl: false,
            fonts: {
                primaryFont: "Domotika",
                secondaryFont: "SquadBlack",
                primaryFontRatio: 1,
            },
        },
        ja: {
            rtl: false,
            fonts: {
                primaryFont: "SquadJp",
                primaryFontRatio: 1,
            },
        },
        ko: {
            rtl: false,
            fonts: {
                primaryFont: "SquadKr",
                primaryFontRatio: 1,
            },
        },
        pl: {
            rtl: false,
            fonts: {
                primaryFont: "Domotika",
                secondaryFont: "SquadBlack",
                primaryFontRatio: 1,
            },
        },
        ru: {
            rtl: false,
            fonts: {
                primaryFont: "SquadRu",
                primaryFontRatio: 1,
            },
        },
        tr: {
            rtl: false,
            fonts: {
                primaryFont: "Domotika",
                secondaryFont: "SquadBlack",
                primaryFontRatio: 1,
            },
        },
        zh: {
            rtl: false,
            fonts: {
                primaryFont: "SquadCn",
                primaryFontRatio: 1,
            },
        },
    },
};
